import { useCallback } from 'react';

import { error as logError } from '@eika-infrastruktur/log';

import checkUrl from '../../utils/checkUrl';
import useQueryParam from '../queryparams/useQueryParam';

const useRedirectOnValidUrl = () => {
    const returnUrl = useQueryParam('returnUrl');
    return useCallback(async () => {
        if (returnUrl) {
            try {
                const valid = await checkUrl(returnUrl);
                if (valid) {
                    window.location.href = returnUrl;
                }
            } catch (e) {
                logError(e);
            }
        }
    }, [returnUrl]);
};

export default useRedirectOnValidUrl;
